module.exports = __webpack_public_path__ + "article-7051a3ee/carlos-barquero-ac3080e4f7a95a6930e971192475e8d2.jpg";